import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/cbt'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(cbt) {
    return http.post(`${resource}`, cbt)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(cbt, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, cbt)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },

}
